import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Installation', path: '/installation' },
    { name: 'Repair', path: '/repair' },
    { name: 'Service', path: '/service' },
    { name: 'Commercial', path: '/commercial' },
    { name: 'About', path: '/about' },
    { name: 'Areas', path: '/areas' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="bg-[#0d1829] border-b border-white/5 sticky top-0 z-50 backdrop-blur-sm bg-opacity-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo-link">
            <div className="flex items-center gap-3">
              <img
                src="/images/deep-control-logo.png"
                alt="Deep Control"
                className="w-12 h-12 object-contain"
                data-testid="header-logo"
              />
              <div>
                <div className="font-bold text-xl tracking-tight leading-none">DEEP CONTROL</div>
                <div className="text-[9px] text-[#FF8C00] tracking-[3px] font-semibold mt-0.5">HVAC SPECIALISTS</div>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#FF8C00] ${
                  location.pathname === link.path ? 'text-[#FF8C00]' : 'text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/ai-estimator">
              <Button className="bg-[#FF8C00] hover:bg-[#FF8C00]/90 text-white font-bold px-6 py-2 rounded-md transition-all" data-testid="header-cta-quote">
                Get Instant Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/5">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors hover:text-[#FF8C00] ${
                    location.pathname === link.path ? 'text-[#FF8C00]' : 'text-white'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/ai-estimator" onClick={() => setMobileMenuOpen(false)}>
                <Button className="bg-[#FF8C00] hover:bg-[#FF8C00]/90 text-white font-bold px-6 py-2 rounded-md w-full mt-2" data-testid="header-mobile-cta-quote">
                  Get Instant Quote
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
